import { render, staticRenderFns } from "./scalapay-cancel.vue?vue&type=template&id=f7a2dd82&"
import script from "./scalapay-cancel.vue?vue&type=script&lang=js&"
export * from "./scalapay-cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports